module.exports = __webpack_public_path__ + "img/pordenone-udine.5a0f327d.png";